<template>
  <div class="component-form">
    <h1 class="form-title">Syllabus Draft</h1>
    <p class="text mt-30">
      A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document and replace all the
      highlighted fields with relevant information pertaining to your seminar. When finished, please upload an editable document to the Portal.
    </p>
    <Button class="btn-download mt-20" skin="grey" @click="handleClickDownload">Syllabus Template</Button>
    <p class="text mt-20">Please upload your syllabus draft here and click submit</p>
    <FileUploader
      class="mt-20 inp-wrap big"
      text="Upload"
      :acceptType="['DOC', 'DOCX', 'PAGES']"
      :value="value.file"
      @input="handleInput($event, 'file')"
      loadText="loading"
      :role="ROLES.SL"
    />
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import ROLES from '../../../../utils/roles';
import { Button, FileUploader } from '../../../../components/form';
export default {
  name: 'SyllabusDraft',
  components: {
    Button,
    FileUploader
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    ROLES() {
      return ROLES;
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    },
    handleClickDownload: function() {
      this.$windowOpen(
        'https://summer-storage.oss-cn-shanghai.aliyuncs.com/cloud-uploads/user-2/CCL/%E9%99%84%E4%BB%B61-2021%E5%93%88%E4%BD%9B%E5%B3%B0%E4%BC%9A%E8%AF%BE%E7%A8%8B%E5%A4%A7%E7%BA%B2%E6%A8%A1%E7%89%88.docx'
      );
    }
  }
};
</script>
